/**
 * RAS / ReportHistory — AuditReportLog browsing.
 *
 * Backend PLANNED. Scaffolds the columns: Timestamp (UTC), Generator,
 * Template code, Parameters JSON, Output file SHA-256, Row count, Delivery
 * method + recipient, Retention tag.
 */

import { Link } from 'react-router';
import { ChevronLeft } from '@retail-ops/panel-shell/fi';
import { Pill } from '@/components/primitives';

const COLUMNS = [
  'Timestamp (UTC)',
  'Generator',
  'Template',
  'Params hash',
  'Output SHA-256',
  'Rows',
  'Delivery',
  'Retention',
];

export function ReportHistory(): JSX.Element {
  return (
    <div>
      <Link
        to="/ras"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 'var(--sp-2)',
          fontSize: 12,
          color: 'var(--pcb-blue)',
          textDecoration: 'none',
          marginBottom: 'var(--sp-4)',
        }}
      >
        <ChevronLeft size={14} /> Back to RAS
      </Link>
      <header style={{ marginBottom: 'var(--sp-6)' }}>
        <h1 style={{ margin: 0 }}>Audit report log</h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--ink-600)' }}>
          Chain-of-custody log of every report generation. 7-year retention per BSA. Survives file
          deletion at SharePoint level.
        </p>
      </header>

      <div
        style={{
          padding: 'var(--sp-5)',
          background: 'var(--info-bg)',
          color: 'var(--info-text)',
          borderRadius: 'var(--r-md)',
          marginBottom: 'var(--sp-6)',
          fontSize: 13,
        }}
      >
        <strong>Backend PLANNED.</strong> <code>GET /v3/audit-reports/log</code> is not live yet.
        Once shipped, this table will render AuditReportLog rows with filters by template, generator,
        and date range.
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <thead>
          <tr style={{ background: 'var(--ink-50)', textAlign: 'left' }}>
            {COLUMNS.map((c) => (
              <th key={c} style={{ padding: 'var(--sp-3)' }}>
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={COLUMNS.length} style={{ padding: 'var(--sp-8)', textAlign: 'center' }}>
              <Pill variant="muted">No rows — awaiting backend</Pill>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
